module.exports = __webpack_public_path__ + "img/5-6.1c0ecf85.png";